import type { CreateRetractationReturnRequestDto, ReturnRequestDto } from "../generated/schema";
import { getReturnWidgetFetchClient } from "./return-widget-client";
import { usePublicApiMutation } from "./use-public-api-mutation";
import { SESSION_TOKEN_KEY } from "./use-session-token";

const authHeader = () => ({ authorization: `Bearer ${localStorage.getItem(SESSION_TOKEN_KEY) ?? ""}` });

export async function publicCreateRetractationReturnRequest(
	body: CreateRetractationReturnRequestDto,
): Promise<ReturnRequestDto> {
	const { data, error } = await getReturnWidgetFetchClient().POST(
		"/public/return-request/retractation",
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		{ params: { header: authHeader() }, body: body as any },
	);
	if (error) throw error;
	return data as ReturnRequestDto;
}

export function usePublicCreateRetractationReturnRequest() {
	return usePublicApiMutation(
		"post",
		"/public/return-request/retractation",
		{
			mapVariables: (body: CreateRetractationReturnRequestDto) => ({
				params: { header: authHeader() },
				body,
			}),
		},
	);
}
